import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Grid, IconButton, Paper, Typography, Box, FormHelperText, SwipeableDrawer, Divider, Avatar, Alert, AlertTitle, Stack } from '@mui/material';
// import Topbanner from '../../images/main-banner.png';

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import RemoveIcon from '@mui/icons-material/Remove';
import Terms from '../../components/saving-league/t&cIndex';
import ButtonComponent from '../../components/saving-league/buttonBottom';
import UserDetail from '../../components/diwali/userDetail';

import Button from '@mui/material/Button';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import EmptyPopUp from "../../components/saving-league/emptyPopup";
import DataPopUp from "../../components/saving-league/DataPopup";
import { getRandomName, namesArray } from './namesArray';
const AvatorBg = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/avator-bg.png";
const AvatarImage = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/avator12.png";
const AvatarImage1 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/Avator1.png";
const AvatarImage2 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/Avator2.png";
const AvatarImage3 = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/Avator3.png";
// import BG from '../../images/diwali/leaderbgs.png';
const BG = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/banner.png";
const borderline = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/Line 124.png";
const TermImg = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/term-white.png";
const BorderIMG = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/border.png";
const Heading = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/register-heading.png";
const Leaderbd = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/lb.png";
const background = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/leaderboard-hero-bg.png";
const BikeImage = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/Prizes.gif";
const leaderboardData = [
    { name: 'YOU', rank: '1000', points: '99,999', avatar: AvatarImage1, highlight: true },
    { name: 'Komal Sunil...', rank: '01', points: '01', avatar: AvatarImage2 },
    { name: 'Komal Sunil...', rank: '01', points: '01', avatar: AvatarImage3 },
    // Add more data as needed...
];
export default function Signup() {

    const navigate = useNavigate();
    const [checked, setChecked] = useState(true); // Set initial state to true for pre-checking

    // Helper function to get display name
    const getDisplayName = (entry, index) => {
        if (entry?.ck_id === userData?.ck_id) {
            return "YOU";
        }
        
        // Check if username is CKite, ckite, or ckites
        const username = entry?.name?.toLowerCase();
        if (username === 'ckite' || username === 'ckites') {
            return namesArray[index] || `User ${index + 1}`;
        }
        
        // Check if name is less than 3 characters, show random name
        if (entry?.name && entry.name.trim().length < 3) {
            return getRandomName();
        }
        
        // Check if username is less than 3 characters, show random name
        if (entry?.username && entry.username.trim().length < 3) {
            return getRandomName();
        }
        
        // Original logic for other usernames
        return (entry?.name && entry.name.trim() !== '' ? entry.name : namesArray[index] || `User ${index + 1}`);
    };

    const [leaderboard, setLeaderboard] = useState([]);
    const [weeklyLeaderboard, setWeeklyLeaderboard] = useState([])
    const [userData, setUserData] = useState(null);
    const [openTermsCondition, setOpenTermsCondition] = useState(false);
    const [openDataPopup, setOpenDataPopup] = useState(false);
    const scrollToElementt = () => { formReff.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    const formReff = useRef(null);
    const [weeklyLastRank, setWeeklyLastRank] = useState();
    const params = new URLSearchParams(window.location.search);
    const ck_id = params.get('ck_id') || localStorage.getItem('savings_league_ck_id_sep');
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    }, []);

    const fetchLeaderboard = async () => {
        try {
            const response = await fetch(`https://leaderboard-1.earningshub.co/api/user/getleaderboard_cdl?ck_id=${ck_id}`);
            const data = await response.json();

            data.rows.unshift({
                name: "YOU",
                rank: data?.user_data?.user?.leaderboards_saving_league_sept?.rank,
                points: data?.user_data?.user?.leaderboards_saving_league_sept?.points,
                users_saving_league_sept: { avatar: data?.user_data?.user?.avatar || 4 },
                highlight: true
            })

            setLeaderboard(data?.rows); // Set leaderboard data
            setUserData(data?.user_data.user); // Set user data
            
            // Debug: Log the API response structure
            console.log('🔍 API Response Debug:', {
                userData: data?.user_data?.user,
                maxUpdatedAt: data?.user_data?.user?.maxUpdatedAt,
                updatedAt: data?.user_data?.user?.leaderboards_saving_league_sept?.updatedAt,
                fullResponse: data
            });

            // Store individual user_data fields in localStorage
            if (data?.user_data?.user?.leaderboards_saving_league_sept) {
                const user = data?.user_data.user?.leaderboards_saving_league_sept;
                localStorage.setItem('savings_points', user.points);
                localStorage.setItem('current_cashback', user.current_cashback);
                localStorage.setItem('updated_at', user.updatedAt);
                localStorage.setItem('savings_rank', user.rank);
                localStorage.setItem('savings_transactions', user.transactions);
                localStorage.setItem('savings_total_order_value', user.total_order_value);
                localStorage.setItem('savings_brand_discovery', user.brand_discovery);
                localStorage.setItem('savings_current_streak', user.current_streak);
                localStorage.setItem('milestone_1', data?.user_data?.user.milestone_1)
                localStorage.setItem('milestone_2', data?.user_data?.user.milestone_2)
                localStorage.setItem('milestone_3', data?.user_data?.user.milestone_3)
                localStorage.setItem('milestone_4', data?.user_data?.user.milestone_4)
                localStorage.setItem('milestone_5', data?.user_data?.user.milestone_5)
                localStorage.setItem('milestone_6', data?.user_data?.user.milestone_6)
                localStorage.setItem('milestone_7', data?.user_data?.user.milestone_7)
                localStorage.setItem('segment', data?.user_data?.user?.segment)
                localStorage.setItem('cashback_goal_1', data?.user_data?.user?.cashback_goal_1)
                localStorage.setItem('free_money_1', data?.user_data?.user?.free_money_1)
                localStorage.setItem('cashback_goal_2', data?.user_data?.user?.cashback_goal_2)
                localStorage.setItem('free_money_2', data?.user_data?.user?.free_money_2)
                localStorage.setItem('cashback_goal_3', data?.user_data?.user?.cashback_goal_3)
                localStorage.setItem('free_money_3', data?.user_data?.user?.free_money_3)
                localStorage.setItem('total_free_money', data?.user_data?.total_free_money)
                localStorage.setItem('last_rank', data?.user_data?.last_rank)
                localStorage.setItem('savings_visit_earn', user?.visit_earn * 10)
            }
        } catch (error) {
            console.error('Error fetching leaderboard:', error);
        }
    };

    const fetchWeeklyLeaderboard = async () => {
        try {
            if (ck_id) {
                const response = await fetch(`https://leaderboard-1.earningshub.co/api/user/getleaderboard_cdl_week?week=1&ck_id=${ck_id}`)
                const data = await response.json()
                
                console.log('Weekly API Response:', data);
                
                // Try multiple possible paths for weekly_last_rank
                let weeklyLastRankValue = data?.weekly_last_rank || 
                                        data?.user_data?.weekly_last_rank || 
                                        data?.user_data?.user?.weekly_last_rank;
                
                console.log('weekly_last_rank found:', weeklyLastRankValue);
                
                setWeeklyLastRank(weeklyLastRankValue);
                
                // Store weekly_last_rank in localStorage
                if (weeklyLastRankValue) {
                    localStorage.setItem('weekly_last_rank', weeklyLastRankValue);
                    console.log('✅ Stored weekly_last_rank in localStorage:', weeklyLastRankValue);
                } else {
                    console.log('❌ No weekly_last_rank found in API response');
                }

                // Only process leaderboard if userData is available
                if (userData) {
                    // Find the user's rank from the existing rows first
                    const userEntry = data.rows.find(row => row.ck_id === ck_id);
                    const userRank = userEntry ? userEntry.rank : (data?.user_data?.user?.leaderboards_saving_league_snapshot_septs?.[0]?.rank || '0');
                    const userPoints = userEntry ? userEntry.points : (data?.user_data?.user?.leaderboards_saving_league_snapshot_septs?.[0]?.points || '0');

                    data.rows.unshift({
                        name: "YOU",
                        rank: userRank,
                        points: userPoints,
                        users_saving_league_sept: { avatar: userData?.avatar || 4 },
                        highlight: true
                    })
                    setWeeklyLeaderboard(data?.rows)
                }
            } else {
                console.log('No ck_id available for weekly leaderboard fetch');
            }
        } catch (error) {
            console.error('Error fetching weekly leaderboard:', error);
        }
    }
    useEffect(() => {
        fetchLeaderboard();
        if (ck_id) {
            fetchWeeklyLeaderboard();
        }
    }, []);

    useEffect(() => {
        // fetchLeaderboard();
        fetchWeeklyLeaderboard()
    }, [userData]);



    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    const [selectedTab, setSelectedTab] = useState('Weekly');

    const handleTabClick = (tab) => {
        setSelectedTab(tab);
    };

    const handlePrizeClick = () => {
        if (userData && (userData?.leaderboards_saving_league_sept?.points)) {
            setOpenDataPopup(true)
        } else {
            setOpenTermsCondition(true)
        }
    }
    const updatedAt = new Date(userData?.leaderboards_saving_league_sept?.updatedAt);

    // subtract 1 day
    updatedAt.setDate(updatedAt.getDate() - 1);

    const formattedDate = updatedAt.getDate().toString().padStart(2, '0') + '/' +
        (updatedAt.getMonth() + 1).toString().padStart(2, '0') + '/' +
        updatedAt.getFullYear();

    localStorage.setItem('formated_date', formattedDate);


    // console.log(`Last updated on ${formattedDate}`);

    return (
        <Grid container sx={{ background: '#fff' }}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} sx={{
                background: '#16131B',
                width: '100%',
            }}>
                {/* <UserDetail /> */}
                <Grid>
                    <Box
                        sx={{
                            backgroundImage: "url('https://d2sriifpjiqv0p.cloudfront.net/diwali/top_bg.png')",
                            backgroundRepeat: 'no-repeat',
                            // webkitBackgroundSize: 'cover',
                            backgroundSize: '100% 100%', // Ensures the image covers the entire container
                            width: "100%",
                            padding: "20px 16px",
                            position: "relative",
                            zIndex: "22"
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '18%' }}>
                            <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/LOGO.png" alt='logo' style={{ width: '85%', }} />

                        </Box>
                        <Grid container spacing={2} sx={{ marginTop: '2%' }}>
                            <Grid item xs={4} mt={0.5}>
                                <Box
                                    sx={{
                                        display: 'flex',         // Enable flexbox layout
                                        flexDirection: 'column', // Stack children vertically
                                        justifyContent: 'flex-end', // Align children to the end of the main-axis (bottom)
                                        backgroundImage: `url(${AvatorBg})`,
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: '100% 100%', // Ensures the image covers the entire container
                                        width: "104px",
                                        height: '200px',
                                        marginRight: '0',
                                        alignItems: "center"
                                    }}
                                >
                                    <Box sx={{
                                        overflow: "hidden",
                                        borderRadius: "16px",
                                        width: "90%",
                                        position: "relative",
                                        bottom: "5px"
                                    }}>
                                        {userData && (
                                            <img
                                                src={require(`../../images/diwali/icon/Avator${userData?.avatar || 4}.png`)}
                                                alt="Avatar"
                                                onError={(e) => {
                                                    e.target.onerror = null; // Prevent an infinite loop in case of errors
                                                    e.target.src = require(`../../images/diwali/icon/Avator4.png`); // Fallback to image 4
                                                }}
                                                style={{
                                                    width: '100%',
                                                    height: '160px',
                                                    objectFit: 'cover', // Ensure the image scales correctly
                                                }}
                                            />
                                        )}
                                    </Box>
                                </Box>
                            </Grid>


                            <Grid item xs={8}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontFamily: 'Montserrat Alternates',
                                        fontWeight: '800',
                                        color: '#fff',
                                        marginBottom: '8px',
                                        fontSize: '1rem'
                                    }}
                                >
                                    {/* {userData?.leaderboards_saving_league_sept?.name} */}
                                    {userData?.leaderboards_saving_league_sept?.name && userData?.leaderboards_saving_league_sept?.name.length > 3 ? userData?.leaderboards_saving_league_sept?.name : 'YOU'}
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <Box
                                            sx={{
                                                // background: "#003FA5",
                                                background: 'linear-gradient(180deg, #FFD83E 0%, #F1A03A 100%)',
                                                borderRadius: '8px',
                                                padding: '8px',
                                                textAlign: 'center',
                                                height: '64px',
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontFamily: 'Metropolis',
                                                    fontWeight: '500',
                                                    fontSize: '10px',
                                                    color: '#212121',
                                                    marginBottom: '4px',
                                                }}
                                            >
                                                Total Points
                                                <img src={BorderIMG} alt='BorderIMG' style={{ width: '100%' }} />
                                            </Typography>
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    fontFamily: '"Montserrat Alternates"',
                                                    fontWeight: '800',
                                                    color: '#212121',
                                                    fontSize: '1.5rem',
                                                    marginTop: '-7%'
                                                }}
                                            >
                                                {userData && userData?.leaderboards_saving_league_sept?.points || '0'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box
                                            sx={{
                                                background: " #FFFFFF33",
                                                borderRadius: '8px',
                                                padding: '8px',
                                                textAlign: 'center',
                                                height: '64px',
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontFamily: 'Metropolis',
                                                    fontWeight: '500',
                                                    fontSize: '10px',
                                                    color: '#fff',
                                                    marginBottom: '4px',
                                                }}
                                            >
                                                Weekly Points
                                                <img src={BorderIMG} alt='BorderIMG' style={{ width: '100%' }} />
                                            </Typography>
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    fontFamily: '"Montserrat Alternates"',
                                                    fontStyle: 'normal',
                                                    fontWeight: '800',
                                                    color: '#fff',
                                                    fontSize: '1.25rem',
                                                    marginTop: '-7%'
                                                }}
                                            >
                                                {weeklyLeaderboard && weeklyLeaderboard.length > 0 ? weeklyLeaderboard[0]?.points || '0' : (userData && userData?.leaderboards_saving_league_snapshot_septs?.[0]?.points || '0')}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Box
                                    variant="contained"
                                    onClick={() => navigate('/savings-league/free-money')}
                                    endIcon={<ArrowForwardIosIcon sx={{ fontSize: '0.75rem' }} />}
                                    sx={{
                                        background: 'linear-gradient(180deg, #FFD83E 0%, #F1A03A 100%)',
                                        borderRadius: '8px',
                                        padding: '6px 10px 10px 10px',
                                        textAlign: 'center',
                                        marginTop: '6px',
                                        // justifyContent: 'space-between',                                        
                                    }}
                                >
                                    <Typography sx={{
                                        color: '#212121',
                                        fontWeight: '500',
                                        // fontFamily: "Montserrat",
                                        fontSize: '10px',
                                        lineHeight: '13px',
                                    }} >Total Free Money</Typography>
                                    <Typography sx={{ fontWeight: '800', fontSize: '24px', lineHeight: '13px', color: '#212121', paddingTop: '8px' }}>{localStorage.getItem('total_free_money') || 0}</Typography>
                                </Box>
                                <Button
                                    variant="contained"
                                    onClick={() => handlePrizeClick()}
                                    endIcon={<ArrowForwardIosIcon sx={{ fontSize: '0.75rem' }} />}
                                    sx={{
                                        background: '#FFFFFF33',
                                        color: '#fff',
                                        fontWeight: '600',
                                        border: '0.5px solid  rgba(255, 255, 255, 0.6)',
                                        fontFamily: '"Montserrat Alternates"',
                                        fontSize: '0.75rem',
                                        textTransform: 'none',
                                        borderRadius: '8px',
                                        padding: '12px',
                                        marginTop: '6px',
                                        justifyContent: 'space-between',
                                        marginBottom: '1rem',
                                        fontStyle: "normal",
                                        boxShadow: 'none',
                                        '&:hover': {
                                            background: '#FFFFFF33', // Keep the background same on hover
                                            boxShadow: 'none', // Remove any box-shadow on hover
                                        },
                                    }}
                                    fullWidth
                                >
                                    Prizes Claimed
                                </Button>

                            </Grid>
                        </Grid>
                        <Box sx={{ justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                variant="caption"
                                sx={{
                                    fontFamily: 'Metropolis',
                                    color: '#fff',
                                    textAlign: 'center',
                                    fontSize: '8px',
                                    fontWeight: '500'
                                }}
                            >
                                <span>*Last updated on {(() => {
                                    // Only show date when userData is loaded
                                    if (!userData) {
                                        return 'Loading...';
                                    }
                                    
                                    // Try multiple possible locations for the date from API only
                                    const dateValue = userData?.maxUpdatedAt || 
                                                     userData?.leaderboards_saving_league_sept?.updatedAt ||
                                                     userData?.updatedAt;
                                    
                                    console.log('🔍 Date Debug:', {
                                        maxUpdatedAt: userData?.maxUpdatedAt,
                                        leaderboardUpdatedAt: userData?.leaderboards_saving_league_sept?.updatedAt,
                                        userUpdatedAt: userData?.updatedAt,
                                        finalDateValue: dateValue
                                    });
                                    
                                    if (dateValue) {
                                        const date = new Date(dateValue);
                                        if (!isNaN(date.getTime())) {
                                            date.setDate(date.getDate() - 1);
                                            return date.toLocaleDateString('en-GB', { 
                                                timeZone: 'Asia/Kolkata'
                                            });
                                        }
                                    }
                                    return 'N/A';
                                })()}</span>

                            </Typography>
                        </Box>

                    </Box>
                </Grid>
                <Grid item xs={12} px={2} pt={5} sx={{ position: 'relative' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={() => navigate('/savings-league/prize-win')}
                        sx={{
                            background: "linear-gradient(91.13deg, #FF5EA6 -9.57%, #C00072 121.67%)",
                            color: '#fff',
                            fontWeight: 600,
                            fontFamily: 'Metropolis',
                            textTransform: 'none',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            overflow: 'hidden', // To clip the image if necessary
                            height: '54px',
                            paddingLeft: '110px', // Add padding to make room for the image
                            position: 'relative',
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '0.875rem',
                                fontWeight: '600',
                                flexGrow: 1, // Ensures the text takes up remaining space
                                textAlign: 'center',
                                fontFamily: 'Metropolis',
                                color: '#fff'
                            }}
                        >
                            Prizes you can win 🎉
                            <ArrowRightAltIcon sx={{ fontSize: '24px', color: '#fff' }} />
                        </Typography>

                    </Button>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '60%',
                            left: {
                                xs: '30px', // Adjust the position on smaller devices
                                sm: '50px', // Standard position on small and larger devices
                            },
                            transform: 'translateY(-50%)', // Center the image vertically
                            width: {
                                xs: '96px', // Smaller image on mobile devices
                                sm: '96px', // Standard image size on small and larger devices
                            },
                            height: {
                                xs: '96px', // Adjust the height to match the width
                                sm: '96px',
                            },
                        }}
                    >
                        <img
                            src="https://d2sriifpjiqv0p.cloudfront.net/diwali/logo.gif"
                            alt="Prize"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover', // Ensures the image covers the area proportionally
                            }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} pt={3.5}>
                    <img src={Leaderbd} alt='Leaderbd' style={{ width: '100%', paddingLeft: '81px', paddingRight: '81px' }} />
                </Grid>
                <Grid item xs={12} sx={{ borderBottom: '1px solid #352066' }} pt={2}>
                    <Button
                        variant="text"
                        onClick={() => handleTabClick('Weekly')}
                        sx={{
                            color: selectedTab === 'Weekly' ? '#FFFFFF' : '#786B95',
                            fontWeight: selectedTab === 'Weekly' ? '600' : '600',
                            borderBottom: selectedTab === 'Weekly' ? '2px solid #7B1FA2' : 'none',
                            fontSize: '14px',
                            borderRadius: 0,
                            textTransform: 'none',
                            padding: '8px 16px',
                            borderRight: '1px solid #352066',
                            fontFamily: selectedTab === 'Weekly' ? 'Metropolis' : 'Metropolis',
                            textShadow: selectedTab === 'Weekly' ? '0px 0px 18px #FFFFFF' : 'none', // Apply white shadow when selected
                            width: '33%',
                            borderBottom: selectedTab === 'Weekly' ? 'none' : 'none',
                        }}
                    >
                        Weekly
                    </Button>

                    <Button
                        variant="text"
                        onClick={() => handleTabClick('Overall')}
                        sx={{
                            color: selectedTab === 'Overall' ? '#FFFFFF' : '#786B95',
                            fontWeight: selectedTab === 'Overall' ? '600' : '600',
                            borderBottom: selectedTab === 'Overall' ? '2px solid #7B1FA2' : 'none',
                            fontSize: '14px',
                            borderRadius: 0,
                            textTransform: 'none',
                            padding: '8px 16px',
                            borderRight: '1px solid #352066',
                            fontFamily: selectedTab === 'Overall' ? 'Metropolis' : 'Metropolis',
                            textShadow: selectedTab === 'Overall' ? '0px 0px 18px #FFFFFF' : 'none', // Apply white shadow when selected
                            width: '34%',
                            borderBottom: selectedTab === 'Overall' ? 'none' : 'none',
                        }}
                    >
                        Overall
                    </Button>
                    <a onClick={scrollToElementt}><Button
                        variant="text"
                        // onClick={() => handleTabClick('T&Cs')}
                        sx={{
                            color: selectedTab === 'T&Cs' ? '#FFFFFF' : '#786B95',
                            fontWeight: selectedTab === 'T&Cs' ? '600' : '600',
                            borderBottom: selectedTab === 'T&Cs' ? '2px solid #7B1FA2' : 'none',
                            fontSize: '14px',
                            borderRadius: 0,
                            textTransform: 'none',
                            padding: '8px 16px',
                            borderRight: '1px solid #352066',
                            fontFamily: selectedTab === 'T&Cs' ? 'Metropolis' : 'Metropolis',
                            textShadow: selectedTab === 'T&Cs' ? '0px 0px 18px #FFFFFF' : 'none', // Apply white shadow when selected
                            width: '33%',
                            borderBottom: selectedTab === 'T&Cs' ? 'none' : 'none',
                        }}
                    >
                        T&Cs
                    </Button></a>

                </Grid>

                <Box sx={{ width: '100%', paddingX: '12px', }} pt={3}>
                    <Grid container sx={{ paddingBottom: '16px', borderBottom: '1px solid #352066' }}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={4}>
                            <Typography
                                sx={{
                                    color: '#AEA2CA',
                                    fontFamily: 'Metropolis',
                                    fontSize: '10px',
                                    fontWeight: '600',
                                    textAlign: 'left',
                                }}
                            >
                                Name
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography
                                sx={{
                                    color: '#AEA2CA',
                                    fontFamily: 'Metropolis',
                                    fontSize: '10px',
                                    fontWeight: '600',
                                    textAlign: 'center',
                                }}
                            >
                                Rank
                            </Typography>
                        </Grid>
                        <Grid item xs={2.7}>
                            <Typography
                                sx={{
                                    color: '#AEA2CA',
                                    fontFamily: 'Metropolis',
                                    fontSize: '10px',
                                    fontWeight: '600',
                                    textAlign: 'right',
                                }}
                            >
                                Points
                            </Typography>
                        </Grid>
                        <Grid item xs={0.3}></Grid>
                    </Grid>

                    {selectedTab === 'Overall' && leaderboard && leaderboard.length > 0 ? (
                        leaderboard.map((entry, index) => (
                            <Grid
                                container
                                key={index}
                                sx={{
                                    height: '64px',
                                    background: entry.highlight ? 'linear-gradient(180deg, #8422BA 0%, #220A3A 100%)'

                                        : `url(${borderline}) no-repeat center bottom`,
                                    backgroundSize: "293px",
                                    borderRadius: entry.highlight ? '8px' : '0',
                                    marginBottom: entry.highlight ? '8px' : '0',
                                    boxShadow: entry.highlight ? '0px 4px 10px rgba(0, 0, 0, 0.1)' : '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }} px={1}>
                                    {entry?.position === 'up' ? <KeyboardArrowUpIcon sx={{ color: '#4BFF53', marginRight: '6px' }} /> : entry?.position === 'down' ? <KeyboardArrowDownIcon sx={{ color: '#FF7171', marginRight: '6px' }} /> : <RemoveIcon sx={{ color: '#fff', marginRight: '6px' }} />}
                                    <Avatar src={require(`../../images/diwali/icon/Avator${entry?.users_saving_league_sept?.avatar || 4}.png`)}
                                        alt={entry?.highlight ? "YOU" : (entry?.name && entry.name.trim() !== '' ? entry.name : namesArray[index] || `User ${index + 1}`)}
                                        sx={{
                                            width: entry.highlight ? '48px' : '40px',
                                            height: entry.highlight ? '52px' : '40px',
                                            marginRight: index === 0 ? '2px' : '8px',
                                            // paddingX: '7px',
                                            textAlign: 'left',
                                            borderRadius: entry.highlight ? '0px' : '100px',
                                            boxShadow: entry.highlight ? 'none' : '0px 0px 10px rgba(255, 255, 255, 0.5)',
                                            alignSelf: entry.highlight ? 'flex-end' : 'center',
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            textAlign: 'center'
                                        }}
                                    >
                                        {/* {entry?.highlight ? "YOU" : (entry?.name && entry.name.trim() !== '' ? entry.name : namesArray[index] || `User ${index + 1}`)} */}
                                        {getDisplayName(entry, index)}

                                    </Typography>
                                </Grid>
                                <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                        }}
                                    >

                                        {entry.rank > 0 ? entry?.rank : Number(localStorage.getItem('last_rank')) + 1}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }} px={1}>
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                        }}
                                    >

                                        {entry?.points || '0'}
                                        
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))
                    ) : (
                        <Typography sx={{ color: '#FFFFFF', textAlign: 'center', }}>
                            {/* No leaderboard data available */}
                        </Typography>
                    )}

                    {selectedTab === 'Weekly' && weeklyLeaderboard && weeklyLeaderboard.length > 0 ? (
                        weeklyLeaderboard.map((entry, index) => (
                            <Grid
                                container
                                key={index}
                                sx={{
                                    height: '64px',
                                    background: entry.highlight ? 'linear-gradient(180deg, #8422BA 0%, #220A3A 100%)'
                                        : `url(${borderline}) no-repeat center bottom`,
                                    backgroundSize: "293px",
                                    borderRadius: entry.highlight ? '8px' : '0',
                                    marginBottom: entry.highlight ? '8px' : '0',
                                    boxShadow: entry.highlight ? '0px 4px 10px rgba(0, 0, 0, 0.1)' : '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }} px={1}>
                                    {entry?.position === 'up' ? <KeyboardArrowUpIcon sx={{ color: '#4BFF53', marginRight: '6px' }} /> : entry?.position === 'down' ? <KeyboardArrowDownIcon sx={{ color: '#FF7171', marginRight: '6px' }} /> : <RemoveIcon sx={{ color: '#fff', marginRight: '6px' }} />}

                                    <Avatar
                                        src={require(`../../images/diwali/icon/Avator${entry?.users_saving_league_sept?.avatar || 4}.png`)}
                                        // src={require(`../../images/diwali/icon/Avator${entry?.users_diwali?.avatar}.png`)}
                                        // src={`../../images/diwali/icon/Avator${entry?.users_diwali?.avatar}.png`}

                                        alt={entry?.highlight ? "YOU" : (entry?.name && entry.name.trim() !== '' ? entry.name : namesArray[index] || `User ${index + 1}`)}
                                        sx={{
                                            width: entry.highlight ? '48px' : '40px',
                                            height: entry.highlight ? '52px' : '40px',
                                            marginRight: index === 0 ? '2px' : '8px',
                                            // paddingX: '7px',
                                            textAlign: 'left',
                                            borderRadius: entry.highlight ? '0px' : '100px',
                                            boxShadow: entry.highlight ? 'none' : '0px 0px 10px rgba(255, 255, 255, 0.5)',
                                            alignSelf: entry.highlight ? 'flex-end' : 'center',
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            textAlign: 'center'
                                        }}
                                    >
                                        {getDisplayName(entry, index)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                        }}
                                    >
{entry?.rank > 0 ? entry.rank : Number(weeklyLastRank?.weekly_last_rank || localStorage.getItem('weekly_last_rank') || 0) + 1}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }} px={1}>
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                        }}
                                    >

                                        {entry?.points || '0'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))
                    ) : (
                        <Typography sx={{ color: '#FFFFFF', textAlign: 'center', mt: 2 }}>
                            {/* No leaderboard data available */}
                        </Typography>
                    )}

                </Box>
                <Grid item xs={12} pb={18} ref={formReff}>
                    <Box px={5} pt={6} pb={4}>
                        <img src={TermImg} alt='termImg' width={'100%'} />
                    </Box>

                    <Terms />
                </Grid>

                <ButtonComponent title="Start Collecting Points" url="/savings-league/play-point" />

                <SwipeableDrawer
                    anchor="bottom"
                    open={openTermsCondition}
                    onClose={() => setOpenTermsCondition(false)}
                    onOpen={() => setOpenTermsCondition(true)}
                    variant="temporary"
                    disableSwipeToOpen={true}
                    ModalProps={{
                        keepMounted: false,
                    }}
                    sx={{ width: "100%", marginX: "10px" }}
                    PaperProps={{
                        elevation: 10,
                        style: { backgroundColor: "transparent" },
                    }}
                >
                    <EmptyPopUp setOpen={openTermsCondition} />
                </SwipeableDrawer>

                <SwipeableDrawer
                    anchor="bottom"
                    open={openDataPopup}
                    onClose={() => setOpenDataPopup(false)}
                    onOpen={() => setOpenDataPopup(true)}
                    variant="temporary"
                    disableSwipeToOpen={true}
                    ModalProps={{
                        keepMounted: false,
                    }}
                    sx={{ width: "100%", marginX: "10px" }}
                    PaperProps={{
                        elevation: 10,
                        style: { backgroundColor: "transparent" },
                    }}
                >
                    <DataPopUp setOpen={openDataPopup} />
                </SwipeableDrawer>


            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4}>
            </Grid>
        </Grid>

    )
};